module.exports = __webpack_public_path__ + "img/Sony_resivedA8F.12386805.png";